import ProductDetailsComponent from '../components/product-details/product-details'

const ProductDetails = () => <ProductDetailsComponent />

export default ProductDetails;